import React, {useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

import NavbarTopContainer from './NavbarTopContainer';

import AppContext from 'config/app-context';


const NavbarTop = () => {
	const {
		config: {
			showBurgerMenu,
			navbarPosition,
			navbarCollapsed
		},
		setConfig
	} = useContext(AppContext);

	const {pathname} = useLocation();
	const isChat = pathname.includes('chat');

	const [showDropShadow, setShowDropShadow] = useState(false);

	useEffect(() => {
		const handleScroll = () => setShowDropShadow(document.documentElement.scrollTop > 0);
		window.addEventListener('scroll', handleScroll);
		return() => window.removeEventListener('scroll', handleScroll);
	}, []);

	const handleBurgerMenuToggle = () => {
		const positionIsTop = navbarPosition === 'top' || navbarPosition === 'double-top';
		const positionIsVerticalOrCombo = navbarPosition === 'vertical' || navbarPosition === 'combo';
		if (positionIsTop) 
			setConfig('navbarCollapsed', !navbarCollapsed);
		
		if (positionIsVerticalOrCombo) 
			setConfig('showBurgerMenu', !showBurgerMenu);
	};

	return (
		<NavbarTopContainer 
			showDropShadow={showDropShadow}
			isChat={isChat}
			navbarPosition={navbarPosition}
			navbarCollapsed={navbarCollapsed}
			handleBurgerMenuToggle={handleBurgerMenuToggle}/>
	);
};

export default NavbarTop;
